import classNames from 'classnames';
import * as React from 'react';

import styles from './SVG.module.css';

type SVGProps = {
    className?: string;
    src: string;
    overflowVisible?: boolean;
    style?: React.CSSProperties;
    fullWidth?: boolean;
    fillWithCurrentColor?: boolean;
};

const SVG = ({
    className,
    src,
    style,
    fullWidth,
    overflowVisible,
    fillWithCurrentColor,
}: SVGProps) => {
    const classes = classNames(className, {
        [styles.Root]: true,
        [styles.fullWidth]: fullWidth,
        [styles.overflowVisible]: overflowVisible,
        [styles.fillWithCurrentColor]: fillWithCurrentColor,
    });

    return (
        <span
            className={classes}
            style={style}
            dangerouslySetInnerHTML={{ __html: src }}
        />
    );
};

export default SVG;
